import { useState } from 'react';
import { useJobs, useArchiveJob } from '../../hooks/useJobs.js';
import { useError } from '../../components/shared/ErrorBanner.jsx';
import JobForm from '../../components/jobs/JobForm.jsx';

export default function JobsPage() {
  const { data: jobs = [] } = useJobs('all');
  const [showForm, setShowForm] = useState(false);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <button className="btn-sm primary" onClick={() => setShowForm(s => !s)}>
          {showForm ? 'Cancel' : '+ New job'}
        </button>
      </div>
      {showForm && <JobForm onDone={() => setShowForm(false)} />}
      {jobs.length ? (
        <table className="tbl">
          <thead>
            <tr>
              <th>Name</th><th>Client</th><th>Geo</th>
              <th className="num">Radius</th><th>Status</th><th></th>
            </tr>
          </thead>
          <tbody>
            {jobs.map(j => <JobRow key={j.id} job={j} />)}
          </tbody>
        </table>
      ) : <div className="loading">No jobs yet.</div>}
    </div>
  );
}

function JobRow({ job }) {
  const [editing, setEditing] = useState(false);
  const archive = useArchiveJob();
  const { show } = useError();

  const onArchive = async () => {
    if (!confirm(`Archive "${job.name}"?`)) return;
    try { await archive.mutateAsync(job.id); } catch (err) { show(err.message); }
  };

  if (editing) {
    return (
      <tr>
        <td colSpan="6" style={{ padding: 0 }}>
          <JobForm initial={job} onDone={() => setEditing(false)} />
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td>{job.name}</td>
      <td>{job.client || '—'}</td>
      <td>
        {job.site_lat != null
          ? <span className="badge orange">{job.site_lat.toFixed(4)}, {job.site_lng.toFixed(4)}</span>
          : <span style={{ color: 'var(--text-muted)' }}>none</span>}
      </td>
      <td className="num">{job.geofence_radius_m}m</td>
      <td><span className={'badge' + (job.status === 'active' ? ' orange' : '')}>{job.status}</span></td>
      <td style={{ textAlign: 'right' }}>
        <button className="btn-sm" onClick={() => setEditing(true)}>Edit</button>{' '}
        {job.status === 'active' && (
          <button className="btn-sm" onClick={onArchive}>Archive</button>
        )}
      </td>
    </tr>
  );
}
